const TRANSLATION = {
  buyModal: {
    afterFree: 'Etter din gratistestperiode',
    btn: 'Prøv gratis',
    freeTrial: '3-dagars gratis prøveperiode',
    monthLabel: 'måned',
    selectLabel: 'Velg et abonnement',
    title: 'Abonnemangsplan',
    yearLabel: 'år',
  },
  contact: {
    block1:
      'For tilpasninger, spørsmål eller forslag, vennligst kontakt oss på contact@noam.tools. Vi svarer umiddelbart.',
    block2: 'Støtt oss ved å rangere oss på Google Apps Extension-butikken med ★★★★★.',
    block3: 'Hjelp andre ved å dele denne utvidelsen:',
    title: 'Kontakt oss',
  },
  help: {
    AquickOverviewOfNoam: 'En rask oversikt over Noam',
    ChatPDF: 'Chat PDF',
    ChatPDF2: 'ChatPDF',
    FavoritesManagement: 'Lagring av favoritter',
    Fixedplugin: 'Reparert plugin',
    Focusing: 'Fokuserer',
    Free: 'Gratis',
    FreeTrialBenefits: 'Fordeler med gratis prøveversjon',
    GoWithWikipedia: 'Bruk Wikipedia',
    GoWithYouTube: 'Bruk YouTube',
    HoverTranslation: 'Hover-øversettelse',
    Howtouse: 'Hvordan bruke',
    ImageTranslation: 'Bildeoversettelse',
    InstantTranslation: 'Umiddelbar oversettelse',
    Membership: 'Medlemskap',
    NoamHelp: 'Noam hjelper deg med å oversette og oppsummere',
    PDFparallelTranslation: 'PDF Parallel Oversettelse',
    ParallelTranslation: 'Parallell oversettelse',
    SkipAllSteps: 'Hopp over alle trinn',
    Summary: 'Sammendrag',
    Translation: 'Oversettelse',
    TryItForFree: 'Prøv det gratis',
    Video: 'Video',
    VideoSummary: 'Videooppsummering',
    VideoTranslation: 'Videotranslasjon',
    WebSummary: 'Weboppsummering',
    WordSelectionTranslation: 'Ordvalgsoversettelse',
    benefits: 'Vi har fordeler som venter på deg!',
    dayFree: '3-dagers gratis prøveperiode',
    done: 'Ferdig',
    next: 'Neste',
    pin: 'Fest Noam for lettere tilgang～～',
    planIsNotExist: 'Planen er ikke tilgjengelig',
    startWiki: 'La oss starte med Wikimedia!',
    startYoutube: 'La oss starte med YouTube!',
    try: 'Prøv det',
    tryNow: 'Prøv det nå!',
  },
  home: {
    PDFTranslate: {
      desc: 'To språk oversettelse + Chat PDF',
      sub1: {
        desc: 'Tvilig lesing lar deg sammenligne originalteksten og oversettelsen side om side, noe som forbedrer leseffektiviteten.',
        title: 'To språks lesing',
      },
      sub2: {
        desc: 'AI analyserer og oppsummerer, og kan svare på dine spørsmål basert på innholdet i PDF-en.',
        title: 'Chat PDF',
      },
      sub3: {
        desc: 'AI-drevet PDF-oversettelse for større nøyaktighet og effektivitet.',
        title: 'Nøyaktighet og effektivitet',
      },
      title: 'PDF Oversett',
    },
    aiAssistant: {
      desc: 'Gjør nettverksøversettelse smartere og mer praktisk',
      panel1: {
        desc: 'To språklige kryssreferansetolkninger hjelper deg med å sammenligne originalteksten med oversettelsen slik at du kan forstå bedre og forbedre leseeffektiviteten din.',
        title: 'Tvåspråkig oversettelse',
      },
      panel2: {
        left: {
          desc: 'Når du bla i en nettside, hold musepekeren over innholdet du trenger å oversette for å se oversettelsen.',
          title: 'Hover-oversettelse',
        },
        right: {
          desc: 'Når du bla i en nettside, velg teksten du ønsker å oversette for å se oversettelsen.',
          title: 'Tekstvalgsoversettelse',
        },
      },
      panel3: {
        one: {
          desc: 'Oversett og oppsummer nettsider og videoinnhold når som helst, hvor som helst, for en jevnere opplevelse!',
          title: 'Pek og klikk',
        },
        three: {
          desc: 'AI-drevet stor språkmodell sikrer oversettelsesnøyaktighet og konsistens for en forbedret leseropplevelse.',
          title: 'AI-drevet',
        },
        two: {
          desc: 'Flerspråklig full dekning, tospråklig barrierefri lesing, oversettelse med ett klikk – opplev forskjellen!',
          title: 'Mer omfattende og praktisk',
        },
      },
      panel4: {
        tab1: {
          desc: 'Din effektivitetsekspert – ved bruk av ChatGPT oversetter og oppsummerer Noam YouTube-videoinnhold for å spare deg tid!',
          key: 'Video',
          title: 'Videooversettelse og -sammanfattning',
        },
        tab2: {
          desc: 'Klikk for å oversette bilder mens du surfer på nettet.',
          key: 'Bilde',
          title: 'Bildeoversettelse',
        },
        tab3: {
          desc: 'Henter umiddelbart nøkkelinformasjon fra nettsider og gir en sammenfatning, noe som forbedrer din leseffektivitet.',
          key: 'Web',
          title: 'Web Oversettelse & Sammendrag',
        },
        tag1: 'Enkel',
        tag2: 'Effektiv',
        tag3: 'Lett å forstå',
      },
      title: 'AI-assistent',
    },
    getStart: 'Kom i gang',
    getStartedForFree: 'Begynn gratis',
    howItWork: {
      desc: 'Noam integrerer AI-modeller for å gi brukere en intelligent opplevelse for flerspråklig nettstedsoversettelse og oppsummering, PDF- og bildeoversettelse, videooversettelse og oppsummering',
      title: 'Hvordan det fungerer',
    },
    lastBlock: { desc: 'Bedre AI-oversettelse for en jevnere leseropplevelse' },
    top: {
      desc: 'Noam er et gratis AI-browserextensjon som hjelper deg med å oversette og oppsummere nettsider, videoer og PDF-innhold.\n      Bli med Noam og opplev magien!',
      title1: 'En Magi',
      title2: 'Én klikk',
    },
    userReviews: {
      desc: 'Femstjerners anmeldelser på Chrome Web Store',
      title: 'Brukeranmeldelser',
    },
  },
  installTips: {
    btn: 'Prøv nå',
    text: 'Installer «Noam Browser Plugin» for å låse opp flere funksjoner! Webkryssreferansering,\n    oppsummering av nettvideoer og mye mer!',
  },
  locale: {
    af: 'afrikaans',
    am: 'amharisk',
    ar: 'arabisk',
    as: 'assamesisk',
    auto: 'Automatisk oppdagelse',
    az: 'aserbajdsjansk',
    ba: 'basjkir',
    bg: 'bulgarsk',
    bn: 'Bengali',
    bo: 'tibetansk',
    bs: 'bosnisk',
    ca: 'katalansk',
    cs: 'tsjekkisk',
    cy: 'walisisk',
    da: 'dansk',
    de: 'tysk',
    dsb: 'Nedersorbisk',
    dv: 'divehi',
    el: 'gresk',
    en: 'Engelsk',
    es: 'spansk',
    et: 'estisk',
    eu: 'baskisk',
    fa: 'persisk',
    fi: 'finsk',
    fil: 'filipino',
    fj: 'fijiansk',
    fr: 'fransk',
    frCA: 'fransk (Canada)',
    ga: 'irsk',
    gl: 'galisisk',
    gom: 'konkani',
    gu: 'gujarati',
    ha: 'hausa',
    he: 'hebraisk',
    hi: 'hindi',
    hr: 'kroatisk',
    hsb: 'Høyre sorbisk',
    ht: 'haitisk kreolsk',
    hu: 'ungarsk',
    hy: 'armensk',
    id: 'indonesisk',
    ig: 'Igbo',
    ikt: 'Inuinnaqtun',
    is: 'islandsk',
    it: 'italiensk',
    iu: 'inuktitut',
    iuLatn: 'inuktitut (latin)',
    ja: 'japansk',
    ka: 'georgisk',
    kk: 'kasakhisk',
    km: 'khemer',
    kmr: 'Kurdisk (nordisk)',
    kn: 'kannada',
    ko: 'koreansk',
    ku: 'Kurdisk (sentrisk)',
    ky: 'kyrgysisk',
    ln: 'Lingala',
    lo: 'Lao',
    lt: 'litauisk',
    lug: 'Ganda',
    lv: 'latvisk',
    lzh: 'Kinesisk (litterært)',
    mai: 'Maithili',
    mg: 'malagasy',
    mi: 'maori',
    mk: 'makedonsk',
    ml: 'malayalam',
    mnCyrl: 'mongolsk (kyrillisk)',
    mnMong: 'mongolsk (tradisjonell)',
    mr: 'marathi',
    ms: 'Malay',
    mt: 'maltesisk',
    mww: 'Hmong Daw',
    my: 'Myanmar',
    nb: 'norsk',
    ne: 'nepali',
    nl: 'nederlandsk',
    noSearchLang: 'Språk støttes ikke',
    nso: 'Sesotho sa Leboa',
    nya: 'Nyanja',
    or: 'Odia',
    otq: 'Querétaro Otomi',
    pa: 'punjabi',
    pl: 'polsk',
    placeholder: 'Søk',
    prs: 'Dari',
    ps: 'pashto',
    pt: 'portugisisk (Brasil)',
    ptPT: 'Portugisisk (Portugal)',
    ro: 'rumensk',
    ru: 'Russisk',
    run: 'Rundi',
    rw: 'kinyarwanda',
    sd: 'sindhi',
    si: 'singalesisk',
    sk: 'slovakisk',
    sl: 'slovensk',
    sm: 'samoan',
    sn: 'Shona',
    so: 'somali',
    sq: 'albansk',
    srCyrl: 'serbisk (kyrillisk)',
    srLatn: 'serbisk (latin)',
    st: 'sesotho',
    sv: 'svensk',
    sw: 'swahili',
    ta: 'tamil',
    te: 'Telugu',
    th: 'thai',
    ti: 'Tigrinya',
    tk: 'turkmener',
    tlhLatn: 'Klingon',
    tlhPiqd: 'Klingon (pIqaD)',
    tn: 'setswana',
    to: 'tonganerin',
    tr: 'tyrkisk',
    tt: 'tatarer',
    ty: 'tahitiansk',
    ug: 'Uyghur',
    uk: 'ukrainsk',
    ur: 'urdu',
    uz: 'Uzbekisk (latin)',
    vi: 'vietnamesisk',
    xh: 'xhosa',
    yo: 'joruba',
    yua: 'yucatekisk maya',
    yue: 'kantonesisk (tradisjonell)',
    zh: 'kinesisk',
    zhHans: 'Forenklet kinesisk',
    zhHant: 'Tradisjonell kinesisk',
    zu: 'Zulu',
  },
  login: {
    and: 'og',
    btn: 'Logg inn med Google',
    btn1: 'Logg inn nå',
    desc: 'Logg inn for å låse opp flere opplevelser',
    policy: 'Personvernpolicy',
    terms: 'Bruksvilkår',
    tips: 'Ved å registrere meg godtar jeg',
    title: 'Velkommen til Noam',
  },
  pageFooter: {
    follow: { facebook: 'Facebook', title: 'Følg', twitter: 'Twitter' },
    legal: { policy: 'Personvernerklæring', terms: 'Servicevilkår', title: 'Juridisk' },
    product: {
      image: 'Bildeoversettelse',
      pdf: 'PDF-oversettelse',
      title: 'Produkter',
      video: 'Videotranslasjon og -oppsummering',
      web: 'Weboversettelse og -oppsummering',
    },
    resources: { title: 'Ressurser' },
    tools: { title: 'Verktøy', pdf: 'PDF-översettelse' },
  },
  pageHeader: {
    contact: 'Kontakt',
    help: 'Hjelp',
    logout: 'Logg ut',
    logoutSucc: 'Logget ut.',
    pricing: 'Priser',
    settings: 'Innstillinger',
    signUp: 'Logg inn',
  },
  pdf: {
    autoDetect: 'Auto-oppdager',
    cancelBtn: 'Avbryt',
    cancelUpload: 'Avbryt',
    chatPdf: {
      summaryError: 'Sammendrag mislyktes, vennligst prøv igjen senere',
      chatError: 'Chatten mislyktes, vennligst prøv igjen senere',
      Search: 'Søk',
      cancel: 'Avbryt',
      chatTitle: 'Velkommen til Noam! Her er en oppsummering av PDFen din:',
      clear: 'Klar',
      clearContent:
        'Dette vil starte en ny samtale. Den nåværende samtalen vil ikke bli lagret. Er du sikker?',
      clearDialogTitle: 'Vennligst bekreft',
      clearSucc: 'Renset',
      copy: 'Kopi',
      copySucc: 'Kopiert',
      delete: 'Slett',
      deleteCancel: 'Avbryt',
      deleteContent: 'Denne PDF-filen kan ikke gjenopprettes etter sletting. Er du sikker?',
      deleteOk: 'Slett',
      deleteSuccess: 'Slettet',
      deleteTitle: 'Bekreft sletting',
      expand: 'Kollaps',
      historyTitle: 'Historie',
      listError:
        'Kunne ikke laste inn leselisten. Vennligst prøv igjen senere eller kontakt support.',
      loading: 'Laster...',
      noDataDesc: 'Ingen historie ennå.',
      noMore: 'Ingen mer innhold.',
      placeholder: 'Spør hva som helst om denne PDFen',
      summaryTitle: 'Du vil kanskje være interessert i disse spørsmålene:',
    },
    collectionEmpty: 'Samlingen din er tom.',
    collectionTab: 'Notater',
    dataLoading: 'Laster...',
    dialogContent: 'Er du sikker på at du vil slette dette?',
    dialogTitle: 'Vennligst bekreft',
    download: {
      both: 'tvåspråklig',
      btn: 'Lagre',
      cancel:
        'Å lukke dette vinduet vil avbryte nedlastingen av PDF-filen. Er du sikker på at du vil avbryte?',
      desc: 'Lagre til enhet: Laster ned oversettelser som bilder; Lagre & Skriv ut: Laster ned oversettelser i originalformat med støtte for kopiering.',
      download: 'Last ned',
      downloadMsg1: 'PDF-oversettelsesstatus:',
      downloadMsg2: 'Forventet gjenværende tid:',
      downloadSucc: 'PDF-en er klar! Klikk for å lagre.',
      downloadTip: 'Laster ned PDF. Lukk ikke dette vinduet for å unngå nedlastingsfeil.',
      error: 'Kunne ikke lagre. Prøv å skrive ut i stedet.',
      fileName: 'Filnavn:',
      fileType: 'Filtype:',
      loading: 'Lagrer...',
      loading2: 'Laster...',
      minute: 'Minutter...',
      msg1: 'Noen oversettelser i dette dokumentet er lengre enn originalteksten og kan overlappe i den nedlastede filen. Vi anbefaler å lese på nettsiden.',
      msg2: 'Oversettelsen er ikke fullført ennå. Last ned etter at oversettelsen er ferdig.',
      msg3: '2. Noen oversettelser er for lange. Les på nettsiden for å unngå tekstoverslag.',
      msg4: 'Oversettelsestasker er i gang. Vennligst prøv igjen etter at de er fullført.',
      progress:
        'Oversetter PDF. Forløp: {{progress}}, Forventet tid igjen: {{minutes}} minutter...',
      save: 'Lagre til enhet',
      savePrint: 'Lagre & Skriv ut',
      success: 'Lastet ned',
      trans: 'Kun oversettelse',
      transContinue: 'Fortsett å oversette',
    },
    downloadBtn: 'Last ned',
    dragTipModal: {
      black: 'rom',
      leftKey: 'venstre knapp',
      ok: 'Forstått',
      press: 'Press',
      tips: 'å dra og se',
    },
    entry: 'PDF-er',
    fileErrMsg: 'Filinnlesing mislyktes. Prøv igjen senere eller kontakt støtte.',
    fileMsg: 'Nåværende filstørrelse:',
    fileMsg2: 'Vennligst last opp en fil mindre enn 300MB.',
    freeBannerBtn: 'Oppgradering',
    freeBannerTips: 'Grense for gratis PDF-oversettelser nådd',
    guide: {
      placeholder: 'Lim inn PDF-lenken her',
      start: 'Start med å oversette',
      text1: 'To språks lesing',
      text2:
        'Les tospråklig for å sammenligne originalteksten og oversettelsen side om side, og forbedre din effektivitet.',
      text3: 'Chat med din PDF',
      text4:
        'AI-drevet analyse og oppsummering. Still spørsmål om PDF-en din og få umiddelbare svar.',
      text5: 'Nøyaktig og effektiv',
      text6: 'AI-drevet PDF-oversettelse for større nøyaktighet og effektivitet.',
      title1: 'To språklig oversettelse',
      title2: 'Chat med din PDF',
      toast: 'Vennligst oppgi en gyldig online PDF-link som slutter med .pdf',
    },
    hasTransTask: 'En oversettelsestopp er i gang. Vennligst vent.',
    hoverTrans: 'Overførsel av avsnitt ved sveiping',
    initial: 'Oversett PDF',
    installText: 'Din en-stop-løsning for daglige oversettelser.',
    installText2: 'Vennligst installer utvidelsen først',
    installTips:
      'Installer utvidelsen for enda flere PDF-oversettelser og jevnere nettsideoversettelser:',
    kw: 'klammer',
    link: 'lenke',
    listError: 'Kunne ikke laste inn PDF-er. Prøv igjen senere, eller kontakt support.',
    memoTotalCount: '1 produkt totalt',
    new: 'ny fil',
    noId: 'Fil-ID ikke funnet.',
    notPdf: 'Kun PDF-filer.',
    okBtn: 'Slett',
    okBtn2: 'Forstått',
    original:
      'Du er en svært nøyaktig og pålitelig AI designet for å generere JSON-utdata som samsvarer nøyaktig med et spesifisert JSON-skjema.\n\nDu må følge disse reglene:\n1. Hensiktsmessig overholde JSON-skjemaets struktur.\n2. Samsvare nøyaktig med alle datatyper, påkrevde felt og begrensninger.\n3. IKKE inkluder noe ekstra tekst, forklaring, markdown eller kommentarer.\n4. Skriv UT KUN JSON-objektet — ingen kodeblokker, ingen forord, ingen wrapping.\n\nSkjemainformasjonen er gitt nedenfor.\n- Skjema Navn: translate_result\n- JSON Skjema:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    parallel: 'Parallel',
    parseErrDialogContent:
      'Denne PDF-lenken kan ikke oversettes direkte. Last ned PDFen og last opp den for oversettelse.',
    parseErrTips: 'Kunne ikke analysere filen',
    parseFileToast: 'Kunne ikke tolke filen. Prøv igjen senere, eller kontakt support.',
    pdfLoading: 'Parserer...',
    searchPlaceholder: 'Søk',
    selectTrans: 'Velg tekst å oversette',
    shareBtn: 'Del',
    shareBtnText1: 'Generer delingslenke',
    shareBtnText2: 'Oppdater delt innhold',
    shareModal: {
      cancel: 'Avbryt',
      copy: 'Kopi',
      copySucc: 'Lenke kopiert',
      custom: 'Tilpass:',
      errMsg: 'Det valgte innholdet er ikke helt oversatt ennå. Vennligst oversett før du deler.',
      gen: 'Del',
      modify: 'Rediger',
      notSupport: 'Denne språket støttes for tiden ikke.',
      page: 'Sider',
      pageNuErr: 'Vennligst skriv inn et gyldig sidesnummer.',
      range: 'Omfang:',
      remain: 'gjenværende',
      remain1: 'Total anslått tid:',
      search: 'Søk',
      settings: 'Delingsinnstillinger:',
      shareSetting: 'Delingsinnstillinger',
      shareText: 'Del',
      shareTips: 'Del lenken til den oversatte PDF-filen med vennene dine:',
      sourceLang: 'Fra:',
      target: 'Til:',
      text1: 'Delingsinnstillinger',
      text2: 'Generer delingslenke',
      totalPage: 'Totalt 1 side',
      trans: 'Oversett',
      translateTips:
        'Tips: Hvis oversettelsen tar lang tid, kan du lukke dette vinduet og dele senere.',
      translating: 'Oversetter PDF...',
      update: 'Oppdater delingslenke',
    },
    shareMsg1: 'Delingslenke generert.',
    shareMsg2: 'Delt innhold oppdatert.',
    shareMsg3: 'Kunne ikke generere delingslenke. Prøv igjen senere eller kontakt støtte.',
    shareMsg4:
      'Kunne ikke oppdatere delt innhold. Prøv igjen senere, eller ta kontakt med support.',
    shareTips: 'PDF-oversettelsen din er klar! Del den med vennene dine.',
    start: 'Start din gratuite prøveperiode',
    thumbnail: 'Innholdsfortegnelse',
    toast1: 'Laster PDF. Prøv igjen senere.',
    toast2: 'PDF-innholdet behandles. Dialog støttes for tiden ikke.',
    toast3: 'Laster ned. Prøv igjen når nedlastingen er fullført.',
    toolbar: { Adjust: 'Juster', autoFit: 'Auto-juster' },
    trans: 'Oversettelse',
    transSucc: 'Oversettelse vellykket!',
    unLoginToast: 'Vennligst logg inn for å bruke denne funksjonen.',
    uploadBtn: 'Last opp',
    uploadErr: 'Filopplastingen mislyktes. Prøv igjen senere eller kontakt support.',
    uploadErrSignUrl: 'Kunne ikke hente opplastings-URL. Prøv igjen senere, eller kontakt support.',
    uploadMsg1: 'Dra og slipp filen din her.',
    uploadMsg2: 'Støttede filtyper: PDF  |  Maks filstørrelse: 300MB',
    uploadMsg3: 'Klikk for å velge eller dra og slipp filer hit.',
    uploading: 'Laster opp',
    uploadingMsg: 'Laster opp. Vennligst vent.',
    uploadingMsg1: 'Fil opplastes. Prøv igjen senere.',
    uploadingMsg2: 'En fil konverteres for tiden. Prøv igjen senere.',
    uploadingMsg3:
      'Forespørsel om konverteringsprosess mislyktes. Prøv igjen senere, eller kontakt støtte.',
    uploadingMsg4:
      'Noam har ikke tilgang til lokale filer. Vennligst last opp en PDF manuelt for oversettelse.',
    uploadingMsg5: 'Kunne ikke hente fil-URL. Prøv igjen senere eller kontakt support.',
    video: 'video',
    vipBannerBtn: 'Oppgradering',
    vipBannerTips: 'Du har nådd grensen for PDF-oversettelser denne måneden.',
    webTrans: 'Fullt kryssreferansesøk',
  },
  pricing: {
    FAQ: 'Ofte stilte spørsmål',
    FQAObj: {
      a1: 'Ja, Noam tilbyr en gratis plan du kan bruke med en gang.',
      a2: 'Vi tilbyr tre medlemsplaner: Pro, Pro+ og Enterprise. Du kan velge å betale månedlig eller årlig. Årlig fakturering gir betydelige besparelser.',
      a3: 'Alle funksjoner er tilgjengelige på begge planene. Den viktigste forskjellen er prisen: årlige abonnementer koster totalt mindre. Månedlige abonnementer faktureres hver måned, mens årlige planer faktureres én gang per år.',
      a4: 'Du kan avbryte abonnementet ditt når som helst i kontoinnstillingene dine.',
      q1: 'Er det en gratis plan?',
      q2: 'Hvilke prispakker og betalingsalternativer er tilgjengelige?',
      q3: 'Hva er forskjellen mellom månedlig og årlig abonnement?',
      q4: 'Hvordan avbryter jeg min abonnement?',
    },
    around: 'Rundt',
    billedMonthly: 'Fakturert månedlig',
    billedYearly: 'Fakturert årlig',
    day: 'dag',
    desc: 'Sammenlign planer og velg den beste',
    detailedCompare: 'Sammenlign planer',
    discount: '20% rabatt',
    enterprise: {
      benefit1: 'Prioritert kundestøtte',
      benefit2: 'Flere brukere',
      benefit3: 'Tilpassede Løsninger',
      benefit5: 'Dedicatedt kontobehandler',
      btn: 'Kontakt oss',
      recommendText: 'Tilpassede planer (≥3 personer)',
      talkToUs: 'Kontakt oss',
    },
    free: {
      benefit1: 'Umiddelbar oversettelse 100 ganger/dag',
      benefit2: 'Nettstedsoversettelse og -oppsummering',
      benefit3: '30 bildeoversettelser',
      benefit4: 'Videooversettelse & Sammendrag',
      benefit5: '10 PDF-oversettelser',
      benefit6: '5 000 tokens',
      btn: 'Prøv gratis',
      recommendText: 'Gratis prøveperiode',
    },
    imageTranslation: 'Bildeoversettelse',
    month: 'måned',
    monthly: 'Månedlig',
    pageTitle: 'Priser',
    pdf: {
      chat: 'PDF-chatforespørsler',
      maxPage: 'Maks. sider per PDF',
      translation: 'PDF-oversettelse',
    },
    preMonth: 'Per måned',
    pro: {
      benefit1: 'Prioritert kundestøtte',
      benefit2: '1 000 000 tokens/måned',
      benefit3: 'Nettstedsoversettelse & Sammendrag',
      benefit4: '200 bildeoversettelser',
      benefit5: 'Videotolkning og -oppsummering',
      benefit6: '200 PDF-oversettelser',
      btn: 'Start',
      recommendText: 'Mest populært',
    },
    proPlus: {
      benefit1: 'Prioritert kundestøtte',
      benefit2: '3 000 000 tokens/måned',
      benefit3: 'Nettstedsoversettelse & Sammendrag',
      benefit4: '500 bildeoversettelser',
      benefit5: 'Videotolkning og -sammanfatning',
      benefit6: '500 PDF-oversettelser',
      recommendText: 'Beste Verdi',
    },
    video: { summary: 'Videooppsummering', translation: 'Videotolkning' },
    web: {
      contrastiveTranslation: 'To språklig oversettelse',
      dictionaryTranslation: 'Valg oversettelse',
      hoverTranslation: 'Hover-oversettelse',
      instantTranslation: 'Umiddelbar oversettelse',
      summary: 'Websidesammendrag',
    },
    yearly: 'Årlig',
  },
  privacy: {
    block1:
      'Noam ("Noam," "vi," "vår" eller "oss") respekterer privatlivet ditt og forpliktet seg til å beskytte all informasjon vi får fra deg eller om deg. Denne personvernpolicyen beskriver våre praksiser angående samling eller bruk av personopplysninger fra bruk av vår nettside, applikasjoner og tjenester (sammensatt kalt "Tjenestene"). Denne personvernpolicyen gjelder ikke for innholdet vi håndterer på vegne av våre forretningsproduktkunder, for eksempel vår API. Bruk av disse dataene er underlagt vårt kundevilkår, som dekker tilgang til og bruk av disse produktene.',
    block10:
      'Vi implementerer kommersielt fornuftige tekniske, administrative og organisatoriske tiltak for å beskytte personopplysninger online og offline mot tap, misbruk, uautorisert tilgang, avsløring, endring eller fiendtlige handlinger. Imidlertid kan ingen internett- eller e-postoverføring garantere full sikkerhet eller nøyaktighet. Spesielt kan e-poster sendt til oss eller fra oss ikke være sikre. Derfor bør du være spesielt forsiktig når du bestemmer hvilke opplysninger du sender til oss via tjenesten eller e-post. Dessuten er vi ikke ansvarlige for noen forstyrrelse av personverninnstillinger eller sikkerhetstiltak i tjenesten eller tredjepartsnettstederes sikkerhetstiltak. Vi vil oppbevare dine personopplysninger så lenge det er nødvendig for oss å levere tjenester til deg eller for andre legitime forretningsformål, for eksempel å løse tvister, sikkerhet og trygghet, eller for å overholde våre juridiske forpliktelser. Lengden på tiden vi oppbevarer personopplysninger avhenger av mange faktorer, for eksempel mengden, naturen, følsomheten til opplysningene, de potensielle risikoene for uautorisert bruk eller avsløring, formålene med behandling av opplysningene, og andre juridisk bindende hensyn.',
    block11:
      'Vi kan oppdatere denne personvernerklæringen fra tid til annen. Når vi gjør det, vil vi legge ut en oppdatert versjon på denne siden, med mindre annet er krevd av gjeldende lovgivning.',
    block12:
      'Hvis du har noen ubesvarte spørsmål eller bekymringer angående denne personvernerklæringen, vennligst kontakt vår kundeservice. E-post:',
    block2: 'Vi samler inn følgende personopplysninger ("Personopplysninger") knyttet til deg:',
    block3:
      'Informasjon levert av deg: Når du oppretter en konto for å bruke våre tjenester eller kommuniserer med oss, samler vi inn personopplysninger som følger:',
    block4:
      'Personlig informasjon som automatisk mottas fra din bruk av tjenestene: Når du får tilgang til, bruker eller samhandler med tjenestene, mottar vi følgende informasjon om din tilgang, bruk eller samhandling («Teknisk informasjon»):',
    block5: 'Vi kan bruke personopplysninger til følgende formål:',
    block6:
      'Sammendrag eller identifiserbar informasjon: Vi kan aggregerere eller fjerne identifikasjon fra personopplysninger for å forhindre at de brukes til identifikasjonsformål, og bruke slike opplysninger til å analysere effektiviteten til våre tjenester, forbedre og legge til funksjoner i våre tjenester, gjennomføre forskning og for lignende formål. Dessuten kan vi analysere den generelle oppførselen og egenskapene til våre tjenestebrukere og dele aggregerte opplysninger med tredjeparter, publisere slike aggregerte opplysninger eller gjøre dem generelt tilgjengelige. Vi kan samle inn aggregerte opplysninger gjennom tjenestene, gjennom informasjonskapsler (cookies) og gjennom andre midler beskrevet i denne personvernpolicyen. Vi vil opprettholde og bruke identifisert informasjon i anonym eller identifisert form, og vi vil ikke forsøke å gjenopprette identifikasjon av slike opplysninger med mindre det kreves av lov.',
    block7:
      'I visse tilfeller kan vi levere dine personopplysninger til tredjeparter uten ytterligere varsel til deg, med mindre loven krever det:',
    block8:
      'Avhengig av din geografiske plassering kan personer i Europeiske økonomiske samarbeidsområde (EØS), Storbritannia og globalt ha visse lovbestemte rettigheter angående deres personopplysninger. For eksempel kan du ha rett til:',
    block9:
      'Tjenesten kan inneholde lenker til andre nettsteder som ikke drives eller kontrolleres av Noam, inkludert sosiale medietjenester ("Tredjepartnettsteder"). Informasjonen du deler med Tredjepartnettsteder vil være regulert av de spesifikke personvernpolicyene og vilkårene for tjenesten til Tredjepartnettsteder, ikke av denne personvernpolicyen. Vi tilbyr disse lenkene for bekvemmelighet og antyder ikke at vi støtter eller har gjennomgått disse nettstedene. Vennligst kontakt Tredjepartnettsteder direkte for informasjon om deres personvernpolicyer og vilkår.',
    subBlock1:
      'Kontoinformasjon: Når du oppretter en konto på vår plattform, samler vi inn informasjon relatert til kontoen din, inkludert navn, kontaktinformasjon, kontoopplysninger, betalingskortinformasjon og transaksjonshistorikk ("Kontoinformasjon").',
    subBlock10: 'Levering, forvaltning, vedlikehold og/eller analyse av tjenester;',
    subBlock11: 'Å kommunisere med deg;',
    subBlock12: 'Utvikling av nye produkter og tjenester;',
    subBlock13:
      'Forebygge svindel, kriminell aktivitet eller misbruk av våre tjenester, og beskytte sikkerheten til våre IT-systemer, arkitektur og nettverk;',
    subBlock14: 'Utførelse av forretningsoverføringer;',
    subBlock15:
      'Overholdelse av juridiske forpliktelser og rettsprosedyrer, beskyttelse av våre rettigheter, personvern, sikkerhet eller eiendom, samt rettighetene, personvernet, sikkerheten eller eiendommen til våre tilknyttede selskaper, deg eller andre tredjeparter.',
    subBlock16:
      'Leverandører og tjenesteleverandører: For å hjelpe oss med å dekke forretningsoperasjonelle behov og utføre visse tjenester og funksjoner, kan vi gi personopplysninger til leverandører og tjenesteleverandører, inkludert hosting-tjenesteleverandører, sky-tjenesteleverandører, andre informasjonsteknologiske tjenesteleverandører, e-postkommunikasjonssoftware og webanalyse-tjenesteleverandører, etc. Disse partnerne vil bare få tilgang til, behandle eller lagre personopplysninger under våre anvisninger når de utfører sine oppgaver for oss.',
    subBlock17:
      'Forretningsoverføringer: Hvis vi inngår i strategiske transaksjoner, reorganiseringer, konkurser, konkursoppkjøp eller overfører tjenester til en annen leverandør (samlet kalt "Transaksjoner"), kan din personlige informasjon og annen informasjon deles med transaksjonsmotparter og andre parter som bistår med Transaksjonene under due diligence, og overføres som en del av Transaksjonene sammen med andre eiendeler til et etterfølger- eller tilknyttet selskap.',
    subBlock18:
      'Lovplikter: Vi kan dele din personlige informasjon med myndigheter, bransjekolleger eller andre tredjeparter, inkludert informasjon om din interaksjon med våre tjenester, (1) hvis det er krevd av lov eller hvis vi mener at en slik handling er nødvendig for å overholde juridiske forpliktelser; (2) for å beskytte og forsvare våre rettigheter eller eiendom; (3) hvis vi ensidig fastslår at det er et overtramp på våre vilkår, retningslinjer eller lover; (4) for å oppdage eller forhindre svindel eller andre ulovlige aktiviteter; (5) for å beskytte våre produkter, ansatte eller brukere, eller offentlig sikkerhet, trygghet, integritet; eller (6) for å forsvare mot juridisk ansvar. ',
    subBlock19:
      'Få tilgang til din personlige informasjon og informasjon om hvordan den behandles.',
    subBlock2:
      'Når du bruker våre tjenester samler vi inn personopplysninger fra dine inputs, opplastede filer eller tilbakemeldinger du sender oss («Innhold»).',
    subBlock20: 'Be om sletting av din personlige informasjon fra våre poster.',
    subBlock21: 'Korriger eller oppdater din personlige informasjon.',
    subBlock22: 'Overfør din personlige informasjon til en tredjepart (dataportabilitet).',
    subBlock23: 'Begrens hvordan vi behandler dine personopplysninger.',
    subBlock24:
      'Trekk tilbake samtykket ditt — når vi er avhengige av samtykke som rettslig grunnlag for behandling, kan du trekke tilbake samtykket ditt når som helst.',
    subBlock25: 'Protestere mot hvordan vi behandler dine personopplysninger.',
    subBlock26: 'Forbedre våre tjenester og utføre forskning;',
    subBlock3:
      'Kommunikasjonsinformasjon: Hvis du sender oss meldinger, vil vi samle inn ditt navn, kontaktinformasjon og innholdet i meldingene dine («Kommunikasjonsinformasjon»).',
    subBlock4:
      'Informasjon om sosiale medier: Vi har sider på sosiale medieplattformer som Instagram, Facebook, Medium, Twitter, YouTube og LinkedIn. Når du samhandler med våre sosiale mediesider, samler vi inn den personlige informasjonen du velger å gi oss, for eksempel dine kontaktoplysninger ("Sosial informasjon"). I tillegg kan selskapene som eidemer våre sosiale mediesider gi oss aggregert informasjon og analyse om våre sosiale medieaktiviteter.',
    subBlock5:
      'Loggdata: Informasjon som sendes automatisk av nettleseren din når du bruker tjenestene våre. Loggdata inkluderer din Internett-protokoll (IP)-adresse, nettlesertype og innstillinger, dato og tid for forespørslene dine, samt hvordan du samhandler med nettstedet vårt.',
    subBlock6:
      'Brukdata: Vi kan automatisk samle inn informasjon om hvordan du bruker tjenesten, for eksempel hvilke typer innhold du ser på eller samhandler med, hvilke funksjoner du bruker, hvilke handlinger du utfører, samt din tidssone, land, tilgangsdato og -tid, brukeragent og versjon, type datamaskin eller mobil enhet, og din datamaskinkobling.',
    subBlock7:
      'Enhetsinformasjon: Dette inkluderer enhetens navn, operativsystem, enhetsidentifikator og nettleseren du bruker. Den innsamlede informasjonen kan avhenge av typen enhet du bruker og dens innstillinger.',
    subBlock8:
      'Cookies: Vi bruker cookies for å drive og administrere våre tjenester samt forbedre din opplevelse. En «cookie» er informasjon sendt fra en nettside du besøker til nettleseren din. Du kan sette opp nettleseren din til å akseptere alle cookies, avvise alle cookies, eller varsle deg når en cookie tilbys slik at du kan bestemme om du vil akseptere den hver gang. Imidlertid kan avvisning av cookies hindre deg i å bruke eller negativt påvirke visningen eller funksjonaliteten til visse områder eller funksjoner på nettsiden. For mer informasjon om cookies, besøk All About Cookies.',
    subBlock9:
      'Analytikk: Vi kan bruke ulike online-analytikkprodukter som bruker informasjonskapsler (cookies) for å hjelpe oss med å analysere hvordan brukere bruker våre tjenester og forbedre din opplevelse når du bruker tjenestene.',
    subTitle1: 'Personlig informasjon vi samler inn',
    subTitle2: 'Hvordan vi bruker personopplysninger',
    subTitle3: 'Offentliggjøring av personopplysninger',
    subTitle4: 'Dine rettigheter',
    subTitle5: 'Lenker til andre nettsteder',
    subTitle6: 'Sikkerhet og lagring av informasjon',
    subTitle7: 'Endring av personvernpolicy',
    subTitle8: 'Hvordan kontakte oss',
    title: 'Personvernerklæring',
    updateTime: 'Oppdatert: 15. mars 2024',
  },
  privacyCollectionPanel: {
    acceptBtn: 'Aksepter alle',
    text: 'For å forbedre din opplevelse bruker vi informasjonskapsler (cookies) til å tilpasse innhold og tjenester.',
    title: 'Denne nettstedet bruker informasjonskapsler',
  },
  slogen: 'Den enkleste AI-assistenten',
  stripe: {
    contact: 'Kontakt oss på contact@noam.tools med eventuelle spørsmål!',
    fail: {
      btn: 'Prøv igjen',
      text1: 'Vi kunne ikke behandle betalingen din.',
      text2: 'Sjekk tilkoblingen din og prøv igjen.',
      title: 'Betaling mislyktes',
    },
    succ: {
      btn: 'La oss gå',
      text1: 'Velkommen til Noam',
      text2: 'la oss begynne!',
      title: 'Gratulerer',
    },
  },
  terms: {
    block1: 'Takk for at du bruker Noam!',
    block10:
      '(a) Priser og fakturering. Du skal betale alle gebyrer ("Gebyrer") i henhold til prisingen og vilkårene på den aktuelle prissiden eller etter det som er avtalt skriftlig mellom oss. Vi forbeholder oss retten til å korrigere priserrekkelser eller feil, selv hvis vi har utstedt fakturaer eller mottatt betaling. Du skal oppgi fullstendig og nøyaktig faktureringsinformasjon, inkludert en gyldig og autorisert betalingsmetode. Vi vil belaste din betalingsmetode med jevne mellomrom i henhold til avtalen, men vi kan fornuftig endre faktureringsdatoen. Du autoriserer Noam, tilknyttede selskaper og tredjepartsbetalingsprosesserere til å belaste din betalingsmetode. Hvis din betaling mislykkes, vil vi gi deg skriftlig varsel og kan suspendere tilgang til tjenesten inntil betalingen er mottatt. Untatt der annet er spesifisert i denne avtalen, er betalinger ikke tilbakebetalbare.',
    block11:
      '(b) Skatter. Med mindre annet er angitt, inkluderer avgiftene ikke noen føderale, statlige, lokale eller utenlandske skatter, toller eller lignende avgifter («Skatter»). Du er ansvarlig for alle Skatter knyttet til dine kjøp, unntatt Skatter basert på vår nettoinntekt som vi vil fakturere deg for. Du godtar å betale slike Skatter umiddelbart, levere oss lovlig gyldige personvernerklæringer, oppnå nødvendige samtykker for behandling av slike data, og du garanterer for oss at du behandler slike data i samsvar med gjeldende lovgivning.',
    block12:
      '(c) Prisendringer. Vi kan endre prisene våre ved å varsle deg via kontoen din og/eller nettstedet vårt. Prisøkninger treder i kraft umiddelbart etter at de er publisert. Eventuelle prisendringer vil gjelde for gebyrer på kontoen din etter endringens virkningsdato.',
    block13:
      '(d) Tvist og forfalne betalinger. Hvis du ønsker å krefte noe avgift eller skatt, vennligst ta kontakt med contact@noam.tools innen tretti (30) dager fra fakturadatoen.',
    block14:
      '(e) Gratis bruk. Du får ikke opprette flere kontoer for å få gratis kreditter. Hvis vi bestemmer at du ikke bruker de gratis kredittene i god tro, kan vi kreve standardavgifter eller stoppe tilgangen til tjenesten.',
    block15:
      '(a) Konfidensialitet. Du kan ha tilgang til konfidensiell informasjon tilhørende Noam. Du kan bare bruke konfidensiell informasjon som tillatt under disse vilkårene med henblikk på bruk av tjenesten. Du får ikke avsløre konfidensiell informasjon til noen tredjepart, og du skal beskytte konfidensiell informasjon på en måte som er minst like beskyttende som du beskytter din egen tilsvarende konfidensiell informasjon, i det minste med rimelig forsiktighet. Konfidensiell informasjon er ikke-offentlig informasjon som er angitt som konfidensiell av Noam eller som rimeligvis bør behandles som konfidensiell under omstendighetene, herunder programvare, spesifikasjoner og annen ikke-offentlig forretningsinformasjon. Konfidensiell informasjon inkluderer ikke informasjon som: (1) blir generelt tilgjengelig for offentligheten uten at du er skyldig; (2) du hadde i din besittelse uten noen forpliktelse til konfidensialitet før du mottok den under disse vilkårene; (3) lovlig avsløres for deg av en tredjepart uten noen konfidensialitetsforpliktelser; eller (4) er uavhengig utviklet av deg uten å bruke den konfidensielle informasjonen. Du kan avsløre konfidensiell informasjon hvis det kreves av lov, domstol eller annen statlig ordre, men du må gi Noam forhåndsvarslet skriftlig på en rimelig måte og, for så vidt mulig, gjøre rimelige anstrengelser for å begrense omfanget av avsløringen, inkludert å hjelpe oss med å motsette oss forespørsler om avsløring.',
    block16:
      '(b) Sikkerhet. Du må implementere rimelige og passende tiltak for å hjelpe til med å beskytte din tilgang til og bruk av tjenesten. Hvis du oppdager noen sårbarheter eller overtrengelser relatert til din bruk av tjenesten, må du umiddelbart kontakte Noam og gi detaljer om sårbarheten eller overtrengelsen.',
    block17:
      '((c) Behandling av personopplysninger. Hvis du bruker tjenesten til å behandle personopplysninger, må du oppgi juridisk tilstrekkelige personvernpåstander og få nødvendig samtykke for behandling av slike opplysninger, og du garanterer oss at du behandler slike opplysninger i samsvar med gjeldende lovgivning.',
    block18:
      'Oppsigelse; Suspensjon. Disse vilkårene treder i kraft fra første gang du bruker tjenesten og forblir i kraft inntil de oppsiges. Du kan oppsige disse vilkårene når som helst og av hvilket som helst grunn ved å slutte å bruke tjenesten og innholdet. Vi kan oppsige disse vilkårene med forhåndsvarsel av hvilket som helst grunn. Vi kan umiddelbart oppsige disse vilkårene ved å gi deg beskjed hvis du krenker avgjørende avsnitt 2 (Brukskrav), avsnitt 5 (Konfidensialitet, sikkerhet og databeskyttelse), avsnitt 8 (Tvistløsning) eller avsnitt 9 (Generelle vilkår), eller hvis forholdet vårt til en tredjepartsteknologileverandør utenfor vår kontroll endres, eller for overholdelse av lover eller myndighetsforespørsler. Vi kan suspendere tilgangen din til tjenesten hvis du ikke overholder disse vilkårene, eller hvis bruk av tjenesten utgjør en sikkerhetsrisiko for oss eller en tredjepart, eller hvis vi mistenker at bruk av tjenesten er svindelaktig eller kan sette oss eller en tredjepart i ansvar.',
    block19:
      '(b) Konsekvenser av opphør. Ved opphør skal du slutte å bruke tjenesten og umiddelbart returnere eller ødelegge all konfidensiell informasjon i henhold til våre instruksjoner. Disse vilkårenes bestemmelser som ved sin natur bør bestå etter opphør eller utløp, herunder men ikke begrenset til avsnitt 3 og 5-9, skal bestå.',
    block2:
      'Disse brukervilkårene gjelder for din bruk av Noams tjenester, inkludert våre programvaregrensesnitt, programvare, verktøy, utviklertjenester, data, dokumentasjon og nettsted (sammensatt referert til som "Tjenestene"). Ved å bruke våre Tjenester samtykker du til å overholde disse vilkårene. Vår personvernpolicy forklarer hvordan vi samler inn og bruker personopplysninger.',
    block20:
      'Erstatningsansvar. Du skal forsvare, erstatte og holde oss, våre tilknyttede selskaper og vårt personale uskadd fra og mot eventuelle krav, tap og utgifter (inkludert advokatgebyrer) som oppstår fra eller er relatert til din bruk av tjenesten, herunder ditt innhold, din bruk av produkter eller tjenester relatert til tjenesten, og din overtrædelse av disse vilkårene eller gjeldende lovgivning.',
    block21:
      '(b) Ansvarsfraskrivelser. Tjenesten leveres "som den er". I den grad loven tillater det, gjør vi, våre tilknyttede selskaper og lisensiere ikke noen erklæringer eller garantier av noen art angående tjenesten, og vi gir ingen garantier, herunder men ikke begrenset til garantier for salgbarhet, egnethet for et bestemt formål, tilfredsstillende kvalitet, ikke-infringerende eller rolig nytelse, samt eventuelle garantier som oppstår fra forretningsforhold eller bransjebruk. Vi garanterer ikke at tjenesten vil være uavbrutt, nøyaktig eller feilfri, eller at innhold vil være sikker, ikke gå tapt eller ikke bli endret.',
    block22:
      '(c) Begrensning av ansvar. Verken vi, våre tilknyttede selskaper eller våre lisensgivere er ansvarlige for indirekte, tilfeldige, spesielle, følgeskader eller straffskader, herunder tap av fortjenester, tap av rykte, tap av bruk, tap av data eller andre immaterielle tap, selv om vi har blitt informert om muligheten for slike skader. I henhold til disse vilkårene overstiger ikke vårt totale ansvar de gebyrer du har betalt for tjenesten i de tolv (12) månedene før kravet eller 100 amerikanske dollar ($100), uansett hva som er størst. Begrensningene i denne seksjonen gjelder i den største grad loven tillater.',
    block23:
      'Betingelsene og din bruk av tjenestene reguleres av lovene i Forente Stater, unntatt amerikansk lovkonfliktsrett. Din bruk av applikasjonen kan også være underlagt andre lokale, statlige, nasjonale eller internasjonale lover. Alle rettssaker eller forhandlinger relatert til disse betingelsene skal kun føres i domstolene i Forente Stater, og du samtykker til å underlegge deg den personlige jurisdiksjonen til slike domstoler.',
    block24:
      'Forholdet mellom partene. Noam og du er uavhengige entreprenører, og ingen av partene har myndighet til å representere eller binde den andre parten eller påta seg forpliktelser for den andre parten uten den andre partens forutgående skriftlige samtykke.',
    block25:
      '(b) Bruk av varemerker. Du får ikke bruke navnet, logotypene eller varemerkerne til Noam eller noen av dens tilknyttede selskaper uten vår forhåndskrevne samtykke.',
    block26:
      'Hvis noen bestemmelse i disse vilkårene fastslås å være ugyldig, ulovlig eller ikke håndhterbar, vil de gjenværende bestemmelsene forblive i full kraft og verksemd.',
    block3:
      'Hvis du er under 18 år gammel, må du få tillatelse fra foreldrene eller juridiske vårdiere dine for å bruke tjenesten. Hvis du bruker tjenesten på vegne av en annen person eller enhet, må du ha autoritet til å akseptere disse vilkårene på deres vegne. Du må oppgi nøyaktig og fullstendig informasjon for å registrere en konto. Du får ikke gi tilgangskredensialer eller konto til noen utenfor organisasjonen din, og du er ansvarlig for alle aktiviteter utført med dine kredensialer.',
    block4:
      '(a) Bruk av tjenesten. Du kan få tilgang til tjenesten under disse vilkårene, og vi gir deg en ikke-eksklusiv rett til å bruke tjenesten. Ved bruk av tjenesten skal du overholde disse vilkårene og alle gjeldende lover. Vi og våre tilknyttede eidende har alle rettigheter, tittel og interesser i tjenesten.',
    block5:
      '(b) Tilbakemelding. Vi setter pris på tilbakemelding, kommentarer, ideer, forslag og forbedringer. Hvis du sender inn slike innhold, kan vi bruke det uten noen restriksjoner og uten å kompensere deg.',
    block6:
      '(c) Restriksjoner. Du får ikke: (1) bruke tjenesten på en måte som krenker, misbruker eller strider mot andres rettigheter; (2) reverseringeniør, dekompilere, demontere, oversette eller på annen måte forsøke å oppdage kildekoden eller underliggende komponenter i tjenestens modeller, algoritmer og systemer (med mindre slike restriksjoner er forbudt av gjeldende lov); (3) bruke resultatene fra tjenesten til å utvikle modeller som konkurranserer med Noam; (4) trekke ut data eller resultater fra tjenesten ved hjelp av automatiserte eller programmeringsmetoder, med mindre tillatt via API, inkludert scraping, web-hentning eller webdatautvinning; (5) fremstille resultatene fra tjenesten som kunstig genererte når de ikke er det, eller på annen måte krenke våre brukspolicyer; (6) kjøpe, selge eller overføre API-nøkler uten vår forhåndsgodkjenning; eller (7) gi oss personopplysninger om barn under 13 år eller gjeldende alder for digital samtykke. Du vil overholde eventuelle hastighetsgrenser og andre krav i vår dokumentasjon.',
    block7:
      '(d) Tredjeparts-tjenester. Alle tredjeparts-software, tjenester eller andre produkter knyttet til tjenesten reguleres av egne vilkår, og vi er ikke ansvarlige for tredjepartsprodukter.',
    block8:
      'Innholdet ditt. Du kan levere inn data ("Input") til tjenesten og motta resultat ("Output") som genereres og returneres basert på Input (samlet referert til som "Content"). Mellom parter, og i den grad lov tillater, eid du alt Input. Noam kan bruke Content til å levere og vedlikeholde tjenesten, overholde gjeldende lover og håndheve våre retningslinjer. Du er ansvarlig for Content, inkludert å sikre at det ikke bryter noen gjeldende lover eller disse vilkårene.',
    block9:
      '(b) Nøyaktighet. Kunstig intelligens og maskinlæring er hurtigt utviklende forskningsfelt. Vi streber kontinuerlig etter å forbedre vår tjeneste for å gjøre den mer nøyaktig, pålitelig, sikker og fordelaktig. Gitt maskinlæringens probabilistiske natur kan bruk av vår tjeneste i visse tilfeller føre til feil utdata, som kanskje ikke reflekterer reelle personer, steder eller fakta nøyaktig. Du bør vurdere nøyaktigheten til eventuelle utdata på passende måte basert på ditt bruksscenario, også ved å gjennomgå utdata manuelt.',
    subTitle1: 'Registrering og tilgang',
    subTitle10: 'Deltagbarhet',
    subTitle2: 'Brukskrav',
    subTitle3: 'Innhold',
    subTitle4: 'Avgifter og betaling',
    subTitle5: 'Konfidensialitet, Sikkerhet og Databeskyttelse',
    subTitle6: 'Løpetid og opphør',
    subTitle7: 'Erstatning; Ansvarsfraskrivelser; Begrensning av ansvar',
    subTitle8: 'Regelgivende lov og jurisdiksjon',
    subTitle9: 'Generelle vilkår',
    title: 'Servicevilkår',
    updateTime: 'Oppdatert: 15. mars 2024',
  },
  trialModal: {
    btn: 'Begynn nå (kun $0,99)',
    chat: 'ChatPDF',
    desc1: 'Etter prøveperioden vil du bli belastet med et årlig gebyr på 180 dollar',
    desc2: 'Avbestill når som helst',
    focus: 'Fokuserer',
    hover: 'Hover-oversettelse',
    image: 'Bildeoversettelse',
    installBtn: 'Installer nå for å motta din gave',
    memo: 'Håndtering av favoritter',
    pdf: 'PDF-parallell oversettelse',
    realtime: 'Umiddelbar oversettelse',
    select: 'Ordvalgsoversettelse',
    title: 'Velkomstgave',
    trialText: '7-dagers prøveperiode',
    video: 'Videotolkning',
    videoSummary: 'Videooppsummering',
    web: 'Parallell oversettelse',
    webSummary: 'Weboppsummering',
  },
  upgradeModal: {
    btn: 'Oppgrader nå',
    chat: {
      free: 'Du har nådd ChatPDF-grensen',
      pro: 'Du har nådd ChatPDF-grensen for denne måneden',
    },
    contactStr: 'Vennligst vent på neste tilbakestilling, eller kontakt oss på contact@noam.tools.',
    limitAlertStr: 'Du har nådd grensen for din gratisplan. Oppgrader for å fortsette.',
    more: 'Se planer',
    pageLimit: { free: 'Du har nådd PDF-sidgrensen' },
    title: 'Erindring',
    upgradeAlertStr: 'Du har nådd grensen for din gratuite plan. Oppgrader for å fortsette.',
    upload: {
      free: 'Du har nådd grensen for PDF-oversettelse',
      pro: 'Du har nådd grensen for PDF-oversettelser denne måneden',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'Bli med nå',
      label: 'Fordeler for nye brukere:',
      remain: 'Kun 30 igjen',
      text: 'Kun 100 plasser tilgjengelig! Ta deg en nå!',
    },
  },
  aiPdfTranslator: {
    title: 'Gratis AI PDF-Oversetter: Oversett PDF med sammenligning på alle språk',
    desc: 'Oversett enkelt PDF-filer til alle språk med AI. Sammenlign originaltekst og oversatt tekst side om side, raskt og gratis.',
    keywords: 'GPT-4、AI-assistent、Oversettelse、Sammendrag、Fokus、ChatPDF、Memo、effektivitet',
    sourceToTarget: {
      title: 'Gratis PDF-øversettelsesverktøy: Oversett {{source}} til {{target}} gratis',
      desc: 'Oversett dine PDF-filer fra hvilket som helst kildespråk til ditt foretrukne språk gratis. Hurtig, nøyaktig og sikker PDF-oversettelse drevet av avansert AI.',
    },
    headerIntroduce: {
      title: 'Noam: Mer enn bare nettbasert oversettelse',
      introduce1: {
        title: 'Noam · PDF-leser',
        desc: '✨Side-by-side-oversettelse + AI-spørsmål og svar. Oversett PDF-er raskt og nøyaktig til ditt målspråk. Still fritt spørsmål om innholdet for å få en dypere forståelse av dine PDF-filer.',
      },
      introduce2: {
        title: 'Noam · Oversettelsesutvidelse for side-ved-side-visning',
        desc: '👏Løs alle dine behov for nettsideoversettelse:',
        detail1: { title: 'Nettstedsoversettelse:', desc: 'Side-by-side tospråklig visning' },
        detail2: { title: 'Ordoversettelse:', desc: 'Enkl klikksnabbøversettelse' },
        detail3: {
          title: 'Umiddelbar oversettelse:',
          desc: 'Oversett ord eller setninger umiddelbart.',
        },
        detail4: { title: 'Bildeoversettelse:', desc: 'Erstatt bilder med oversatte.' },
        detail5: {
          title: 'Videotolkning:',
          desc: 'To språk med undertekster for bedre seeropplevelse.',
        },
        footer: 'Opplev flere AI-drevne lesefunksjoner for smarter oversettelse!',
      },
    },
    subtitle: 'PDF Oversett Online Gratuit',
    introduce: {
      module1: {
        detail1: {
          title: 'Ekte tid side-for-side PDF-øversettelse',
          desc1:
            'Vis opprinnelig og oversatt innhold umiddelbart i et synkronisert, side-ved-side-layout',
          desc2: 'Sammenlign begge versjonene enkelt med synkronisert scrolling',
          desc3: 'Behold identisk formatering for en konsistent leseropplevelse',
        },
        detail2: {
          title: 'Nøyaktig innholdsjustering og verifisering',
          desc1: 'Perfekt avstemmning mellom killetekst og oversatt tekst for enkel verifisering',
          desc2: 'Hvert innholdssegment samsvarer nøyaktig mellom begge versjonene',
          desc3: 'Raskt oppdage og løse oversettelsesavvik for pålitelige resultater',
        },
      },
      module2: {
        detail1: {
          title: 'Flere avanserte AI-modeller for nøyaktig oversettelse',
          desc1: 'Velg blant ledende AI-modeller for å møte dine oversettelsesbehov',
          desc2: 'Sikre optimale resultater for ulike dokumenttyper og bransjer',
          desc3: 'Fleksible modellentrekk gir skreddersydde løsninger for hvert scenario',
        },
        detail2: {
          title: 'Avansert AI-øversettelse for alle innholdstyper',
          desc1: 'Vår kraftige AI-modell sikrer høy nøyaktighet og forståelse av naturlig språk',
          desc2: 'Håndterer tekniske, akademiske og kreative dokumenter med letthet',
          desc3: 'Leverer pålitelige resultater for alle dine oversettelsesbehov',
          desc4: 'Intelligent tilpasning til forskjellige innholdstyper for optimal ytelse',
        },
      },
      module3: {
        detail1: {
          title: 'Intelligent Dokumentinteraksjon',
          desc1: 'Chatt uanstrengt med dine PDF- og presentasjonsfiler ved hjelp av avansert AI',
          desc2: 'Still spørsmål om dokumentinnhold umiddelbart og få nøyaktige svar',
          desc3: 'Generer raskt konsise sammenfattninger av lange dokumenter',
        },
        detail2: {
          title: 'Dyp innholdsanalyse og sømløs integrasjon',
          desc1: 'Hent ut nøkkelinformasjon og analyser komplekse data med AI-drevet forståelse',
          desc2: 'Få innsikt i tekniske, akademiske eller kreative materialer',
          desc3:
            'Integreres sømløst med vår PDF-oversetter for en fullstendig dokumenthåndteringsløsning',
        },
      },
      module4: {
        detail1: {
          title: 'Ut over PDF-oversettelse: All-i-én løsning for nettsideoversettelse',
          desc: 'Oppdag vår kraftige side-til-side oversettelsesutvidelse designet for alle online lesescenarier.',
          desc1:
            'Nettstedsoversettelse: Nyt tospråklig innhold med en synkronisert side-ved-side-visning',
          desc2: 'Ordetoversettelse: Oversett markerte ord umiddelbart med ett klikk',
          desc3:
            'Umiddelbar oversettelse: Oversett enhver tekst eller setning med en gang for rask forståelse',
          desc4: 'Bildeoversettelse: Erstatt automatisk originale bilder med oversatte versjoner',
          desc5:
            'Videotolkning: Se videoer med tospråklige undertekster for en forbedret opplevelse',
        },
      },
    },
    question: {
      title: 'Ofte stilte spørsmål',
      answer1: {
        title: 'Er Noam PDF Translator gratis å bruke for PDF-oversettelse?',
        content:
          'Ja, du kan oversette PDF-er gratis med Sider PDF Translator! Vi tilbyr en gratis kvote på 5 000 tokens, som er tilstrekkelig til å oversette de fleste PDF-dokumenter som vanligvis finnes på markedet. Hvis du trenger å oversette større filer eller trenger avanserte funksjoner, kan du velge å oppgradere til våre premium-planer for enda flere muligheter.',
      },
      answer2: {
        title: 'Hvor nøyaktig er Noam PDF Translator?',
        content:
          'Noam PDF-oversetter leverer svært nøyaktige oversettelser ved å bruke avansert AI-teknologi og dyp forståelse av konteksten i dokumentene dine. Selv om ingen automatisk oversettelse er feilfri, gjør vår side-til-side-visning det enkelt for deg å gjennomgå og forbedre hver oversettelse, slik at det endelige resultatet oppfyller dine kvalitetsforventninger. Opplev pålitelig og nøyaktig PDF-oversettelse med Noam.',
      },
      answer3: {
        title: 'Kan jeg oversette skannede PDF-er?',
        content:
          'Ja, du kan oversette skannede PDF-er med vår innebygde OCR-teknologi (Optisk Tegnsannsynlighet). Vårt system trekker automatisk ut tekst fra skannede dokumenter og bildebaserte PDF-er, og oversetter deretter innholdet for deg. Dette sikrer at til致使 ikke-redigerbare eller bare-bilde PDF-er kan oversettes nøyaktig.',
      },
      answer4: {
        title: 'Hvor lang tid tar oversettelse?',
        content:
          'Oversettelse er rask og effektiv – de fleste dokumenter behandles på få sekunder til noen minutter, avhengig av deres lengde og kompleksitet. For eksempel tar en standard 10-sidig PDF vanligvis mindre enn 2 minutter å oversette. Nyt korte leveranstider for alle dine behov for dokumentoversettelse!',
      },
      answer5: {
        title: 'Kan jeg beholde sidevisningen for lesing?',
        content:
          'Ja, du kan alltid lese dokumentene dine side ved side. Denne layouten lar deg sammenligne originalinnholdet og det oversatte innholdet enkelt, noe som sikrer en jevn og effektiv leseopplevelse.',
      },
    },
    freeTrial: 'Gratis prøveperiode',
    toLanguage: { title: 'PDF AI-oversettelsesparet', item: '{{target}}' },
  },
  aiPdfTranslate: {
    header: {
      features: 'Funksjoner',
      pricing: 'Priser',
      blog: 'Blogg',
      button: 'Oversett nå',
      faq: 'Ofte stilte spørsmål',
    },
    hero: {
      upload: {
        title: 'Last opp PDFen din',
        highlight: 'Klikk for å bla',
        desc: 'eller dra og slipp',
        max: 'Max',
      },
      pill: 'AI-drevet PDF-omsetter',
      title: 'Gratis PDF-oversetter',
      to: 'til',
      model: 'GPT-4 & Claude',
      desc: 'Umiddelbare, nøyaktige oversettelser som bevarer opprinnelig layout. Noam AI støtter OCR og side-for-side-visninger.',
      support: 'OCR-støtte',
      translated: 'Oversatt av Noam',
      free: 'Gratis prøveperiode',
      complete: 'Oversettelse fullført',
    },
    ticker: {
      pdf: 'PDF-oversettelse',
      ocr: 'OCR-teknologi',
      side: 'Side-by-Side',
      format: 'Formatbevaring',
      multi: 'Flerspråklig',
      chat: 'Chat med PDF',
      web: 'Weboversettelse',
      secure: 'Sikker & Privat',
    },
    comparison: {
      bad: {
        title: 'Standardoversettelse',
        head: 'Formatering og kontekst tapt',
        text1: 'Feil: Layout ødelagt. Bilder plassert feil.',
        text2:
          'Teksten overlapper og skrifttyper er inkonsistente. Vanskelig å lese og uprofesjonelt...',
      },
      dump: { title: 'Ren tekstdump' },
      good: {
        title: 'Noam AI-oversettelse',
        tag: 'Perfekt resultat',
        sub: 'Perfekt formatering, kontekstavis',
      },
      title: 'Hvorfor velge Noam AI?',
      desc: 'Slutt å kjempe med kopier-og-lim oversettelse. Opplev forskjellen mellom standardverktøy og vår AI-drevne kontekstbevisste oversettelse.',
    },
    showcase: {
      kicker: 'STØTTETE DOKUMENTER',
      title1: 'Ethvert dokument',
      title2: 'Enhver språk',
      carousel1: 'Kunst',
      carousel2: 'Arkitektur',
      carousel3: 'Vitenskapelig tidsskrift',
      carousel4: 'Medisin',
      note: 'Håndter tekniske, akademiske og kreative dokumenter med letthet.',
      carousel6: 'Lov',
      carousel5: 'Finans',
      carousel7: 'Kontrakt',
      carousel8: 'Policy',
    },
    features: {
      big: {
        title: 'Avanserte AI-modeller (GPT-4, Claude)',
        desc: 'Velg blant ledende AI-modeller for å matche dine oversettelsesbehov. Sikre optimale resultater for ulike dokumenttyper.',
      },
      grid1: {
        title: 'OCR-støtte',
        desc: 'Trekk ut og oversett tekst fra skannede PDF-er og bilder umiddelbart.',
      },
      grid2: {
        title: 'Høyoppløsningsutgang',
        desc: 'Last ned dine oversatte dokumenter i PDF-format med opprinnelig layout.',
      },
      grid3: {
        title: 'Sammenligning side om side',
        desc: 'Synkronisert scrolling for å sammenligne opprinnelig og oversatt tekst.',
      },
      title2: 'Det er en revolusjon',
      title1: 'Mer enn bare oversettelse',
      line1: 'Teknisk artikkel.pdf',
      line2: 'Oppdager språk: Engelsk...',
      line3: 'Modell: GPT-4o (Høy presisjon)',
      line4: 'Oversettelse fullført (99 % nøyaktighet)',
    },
    testimonials: {
      review1: {
        role: 'Forsker',
        content:
          'Noam AI sparte meg timer med oversettelse av vitenskapelige artikler. Den side-til-side-visningen er utrolig nyttig for å verifisere tekniske termer.',
      },
      review2: {
        role: 'Global Markedsfører',
        content:
          'Den beste PDF-oversetteren jeg har brukt. Den bevarer den opprinnelige formateringen perfekt, noe som er avgjørende for våre markedsføringspresentasjoner.',
      },
      review3: {
        role: 'Juridisk konsulent',
        content:
          'Nøyaktig og raskt. Jeg bruker den til kontraktsübersettelser, og OCR-funksjonen for skannede dokumenter fungerer feilfritt.',
      },
      kicker: 'ELSKET AV BRUKERE',
      title: 'Hva brukere våre sier',
    },
    cta: {
      button: 'Start å oversette gratis',
      title: 'Klar til å bryte språkbarrierer?',
      desc: 'Bli med 10 000+ brukere og start å oversette dokumentene dine med Noam AI i dag.',
      hint: 'Du er en svært nøyaktig og pålitelig AI designet for å generere JSON-utdata som samsvarer nøyaktig med et spesifisert JSON-skjema.\n\nDu må følge disse reglene:\n1. Strikt overholde JSON-skjemastrukturen.\n2. Samsvare nøyaktig med alle datatyper, påkrevde felt og begrensninger.\n3. IKKE inkluder noe ekstra tekst, forklaring, markdown eller kommentarer.\n4. Skriv UT KUN JSON-objektet — ingen kodeblokker, ingen forord, ingen omkledning.\n\nSkjemainformasjonen er gitt nedenfor.\n- Skjemanavn: translate_result\n- JSON-skjema:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    },
    languagePairs: {
      title: 'Engelske PDF AI-øversettelsespare',
      desc: 'Populære oversettelsesretninger støttet av Noam AI',
    },
    footer: { about: 'Om oss', privacy: 'Personvernerklæring', contact: 'Kontakt support' },
  },
}

export default TRANSLATION
